module.exports = __webpack_public_path__ + "static/kwame.7124fd9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/quote_assets/kwame.png
// module id = 1112
// module chunks = 35783957827783